define('model/WaitingListHelperModel',['require','lib/model/BaseModel','collection/WorkingDayCollection','Config'],function (require) {

	var BaseModel = require('lib/model/BaseModel');
	var WorkingDayCollection = require('collection/WorkingDayCollection');

	var Config = require('Config');

	/**
	 * Waiting list helper model
	 * 
	 * @class WaitingListHelperModel
	 */
	return BaseModel.extend({
		
		url: '/waiting-list-helper/',

		bookingModel : null,
		companyTimeZone : null,
		clientTimeZone : null,
		timeValidateModel : null,
		calendarCollection : null,

		defaults: {
			id: null,
		},
		
		initialize: function () {
			BaseModel.prototype.initialize.call(this);
		},

		getCurrentDate: function(){
			return this.getBookingModel().get('start_date');
		},

		isTodayOrFutureDates : function(startDate, endDate){
			var isAv = false;
			if(!startDate && !endDate) {
				startDate = this.getBookingModel().get('start_date');
				endDate = this.getBookingModel().get('end_date');
			}
			//console.log(startDate, endDate);

			if(!startDate && !endDate){
				return false;
			}
			if(startDate && !endDate){
				endDate = startDate;
			}

			startDate = Date.parseMysqlDate(startDate);
			endDate = Date.parseMysqlDate(endDate);
			var i = new Date();
			var now = new Date()
			var nowDate = now.getDate(), nowMonth = now.getMonth(), nowYear = now.getFullYear();
			nowDate = new Date(nowYear, nowMonth, nowDate);

			for(i.setTime(startDate.getTime()); i<=endDate; i.setDate(i.getDate() + 1) ) {
				var iDate = i.getDate(), iMonth = i.getMonth(), iYear = i.getFullYear();
				iDate = new Date(iYear, iMonth, iDate);

				if(iDate >= nowDate){
					isAv = true;
					break;
				}
			}
			return isAv;
		},

		isWorkDateInterval : function (dayFrom, dayTo){
			if(!dayFrom && !dayTo){
				dayFrom = this.getBookingModel().get('start_date');
				dayTo = this.getBookingModel().get('end_date');
			}

			if(!dayFrom && !dayTo){
				return true;
			}

			if(dayFrom && !dayTo){
				dayTo = dayFrom;
			}

			dayFrom = Date.parseMysqlDate(dayFrom);
			dayTo = Date.parseMysqlDate(dayTo);
			var i = new Date();
			var isModelExist = true;

			for(i.setTime(dayFrom.getTime()); i<=dayTo; i.setDate(i.getDate() + 1) ) {
				if(!this.getCalendarCollection().get(i.getMysqlDate())){
					//console.log(i.getMysqlDate() + ' date not in calendar collection');
					isModelExist = false;
				}
			}


			var isWorkDay = true;
			var result = [];

			for(i.setTime(dayFrom.getTime()); i<=dayTo; i.setDate(i.getDate() + 1) ) {
				//result[i.getMysqlDate()] = this.getCalendarCollection().isDayOff(i.getMysqlDate(), this.getTimeDiff());
				isWorkDay = !this.getCalendarCollection().isDayOff(i.getMysqlDate(), this.getTimeDiff());
				var model = this.getCalendarCollection().get(i.getMysqlDate());
				if(model && model.get('is_wl_available') === false){
					isWorkDay = false;
				}
				if(!isWorkDay){
					return false;
				}
			}

			return isWorkDay;
		},

		setModels : function (params) {
			var _this = this;
			_.each(params, function (model, key) {
				switch (key) {
					case 'bookingModel':
						_this.setBookingModel(model); break;
					case 'companyTimeZone':
						_this.setCompanyTimezoneModel(model); break;
					case 'clientTimeZone':
						_this.setClientTimeZoneModel(model); break;
					case 'timeValidateModel':
						_this.setTimeValidateModel(model); break;
				}
			});
		},

		getTimeDiff: function () {
			var diff = this.getClientTimeZoneModel().get('time_diff');
			var supportedTimelines = [
				Config.TIMELINE_SLOTS, Config.TIMELINE_CLASSES_PLUGIN, Config.TIMELINE_GRID_WEEKLY, Config.TIMELINE_SLOTS_WEEKLY
			];
			if (!_.contains(supportedTimelines, Config.getInstance().getTimelineType())) {
				diff = 0;
			}
			return diff;
		},

		setBookingModel : function (bookingModel) {
			this.bookingModel = bookingModel;
		},

		getBookingModel : function(){
			return this.bookingModel;
		},

		setCompanyTimezoneModel : function (companyTimeZone){
			this.companyTimeZone = companyTimeZone;
		},

		getCompanyTimezoneModel : function(){
			return this.companyTimeZone;
		},

		setClientTimeZoneModel : function (clientTimeZone){
			this.clientTimeZone = clientTimeZone;
		},

		getClientTimeZoneModel : function(){
			return this.clientTimeZone;
		},

		setTimeValidateModel : function (timeValidateModel){
			this.timeValidateModel = timeValidateModel;
		},

		getTimeValidateModel: function(){
			return this.timeValidateModel;
		},

		setCalendarCollection : function (calendarCollection){
			var _this = this;
			this.calendarCollection = calendarCollection;

			this.listenTo(calendarCollection, 'sync', function(){
				//console.log('sync');
				_this._onChangeChild('calendar');
			});
		},

		_onChangeChild : function(type){
			this.trigger('change', type);
		},

		getCalendarCollection: function(){
			if(!this.calendarCollection){
				this.calendarCollection = new WorkingDayCollection();
			}
			return this.calendarCollection;
		},
	});
	
});
